
import HomeService from "@/services/HomeService"

let SITE_KEY = null
declare global {
  interface Window {
    onRecaptchaLoadCallback: () => void
    grecaptcha: {
      ready(onReady: () => void)
      execute(key: string, action: { action: string }): Promise<string>
    }
  }
}

async function loadRecaptcha() {

  const config = await HomeService.getRecaptchaConfig()
  if(!config.enabled){
    return
  }
  SITE_KEY = config.siteKey
  return new Promise<void>((resolve, reject) => {
    if (document.querySelector('script[src*="recaptcha/api.js"]')) {
      resolve()
      return
    }
    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoadCallback&render=${SITE_KEY}`
    script.async = true
    script.defer = true
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA'))
    document.head.appendChild(script)
    window.onRecaptchaLoadCallback = () => {
      resolve()
    }
  })
}
async function getCaptchaToken(action: string): Promise<string> {
  await loadRecaptcha()
  return new Promise<string>((resolve, reject) => {
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(SITE_KEY, {
          action: action
        })
        resolve(token)
      } catch (error) {
        reject(error)
      }
    })
  })
}

export { getCaptchaToken }
